import React from 'react'

import { DeviceMultiSelect } from './DeviceMultiSelect'

interface DeviceAssignmentFieldProps {
  selected: string[]
  catalog: string[]
  onChange: (nextSelected: string[], nextCatalog: string[]) => void
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

export const DeviceAssignmentField: React.FunctionComponent<DeviceAssignmentFieldProps> = (
  props,
) => {
  const { selected, catalog, onChange, isOpen, onOpenChange } = props
  return (
    <DeviceMultiSelect
      catalog={catalog}
      selected={selected}
      onChange={onChange}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      inputPlaceholder="Type or paste IDs (e.g. 10020, 10021)..."
    />
  )
}
